export const SEND_HELP_WIDGET_MESSAGE_STARTED = 'SEND_HELP_WIDGET_MESSAGE_STARTED'
export const SEND_HELP_WIDGET_MESSAGE_SUCCESS = 'SEND_HELP_WIDGET_MESSAGE_SUCCESS'
export const SEND_HELP_WIDGET_MESSAGE_FAILURE = 'SEND_HELP_WIDGET_MESSAGE_FAILURE'
